import { defineContainer } from './vue-component-lib/utils';
export const CmAccordion = defineContainer('cm-accordion', undefined, [
    'sections',
    'removeIcon',
    'removed'
]);
export const CmAlertBar = defineContainer('cm-alert-bar', undefined, [
    'color',
    'alertTitle',
    'text',
    'iconName',
    'link'
]);
export const CmAutocomplete = defineContainer('cm-autocomplete', undefined, [
    'type',
    'size',
    'placeholder',
    'label',
    'error',
    'required',
    'name',
    'disabled',
    'multiple',
    'hideBottomSpacing',
    'hideDeleteIconTag',
    'hintTooltip',
    'value',
    'clearable',
    'prependIcon',
    'appendIcon',
    'items',
    'noItemText',
    'cm-change',
    'search'
], 'value', 'v-on-change');
export const CmBadge = defineContainer('cm-badge', undefined, [
    'size',
    'color'
]);
export const CmBreadcrumbs = defineContainer('cm-breadcrumbs', undefined, [
    'items'
]);
export const CmButton = defineContainer('cm-button', undefined, [
    'size',
    'buttonStyle',
    'color',
    'prependIcon',
    'appendIcon',
    'disabled',
    'fullWidth',
    'hovered'
]);
export const CmButtonGroup = defineContainer('cm-button-group', undefined, [
    'buttons',
    'size',
    'multiple',
    'color',
    'disabled',
    'selected'
]);
export const CmCol = defineContainer('cm-col', undefined, [
    'sm',
    'md',
    'lg',
    'xl'
]);
export const CmCollapse = defineContainer('cm-collapse', undefined, [
    'value',
    'iconSize',
    'iconColor',
    'hideIcon',
    'removeIcon',
    'removed'
]);
export const CmContainer = defineContainer('cm-container', undefined);
export const CmDropdown = defineContainer('cm-dropdown', undefined, [
    'entries',
    'autocomplete',
    'disabled',
    'acText',
    'side',
    'disableActivateOnHover',
    'selectOptions',
    'selectable',
    'value',
    'notVisible',
    'opened'
]);
export const CmFab = defineContainer('cm-fab', undefined, [
    'size',
    'buttonStyle',
    'color',
    'rounded',
    'iconName',
    'disabled'
]);
export const CmFooter = defineContainer('cm-footer', undefined, [
    'cols',
    'socials',
    'terms',
    'copyright',
    'auth',
    'bakers',
    'bakersLogos'
]);
export const CmIcon = defineContainer('cm-icon', undefined, [
    'iconName',
    'size',
    'color'
]);
export const CmInput = defineContainer('cm-input', undefined, [
    'type',
    'size',
    'placeholder',
    'label',
    'error',
    'required',
    'value',
    'name',
    'autoFocus',
    'disabled',
    'max',
    'min',
    'hideBottomSpacing',
    'clearable',
    'hintTooltip',
    'prependIcon',
    'appendIcon',
    'readonly',
    'cm-change'
], 'value', 'v-on-change');
export const CmJobCard = defineContainer('cm-job-card', undefined, [
    'logoSrc',
    'companyName',
    'jobName',
    'jobRemoteness',
    'jobSalary',
    'jobSchedule',
    'jobLocation',
    'status',
    'jobSkills',
    'grow'
]);
export const CmLink = defineContainer('cm-link', undefined, [
    'size',
    'icon',
    'href',
    'action'
]);
export const CmMediaCard = defineContainer('cm-media-card', undefined, [
    'mediaSrc',
    'mediaBadge',
    'logoSrc',
    'headCaption',
    'headTitle',
    'headParagraph',
    'tags',
    'ctaRow',
    'link',
    'grow'
]);
export const CmModalAlert = defineContainer('cm-modal-alert', undefined, [
    'show',
    'hideBackdrop',
    'iconName',
    'iconColor',
    'modalTitle',
    'modalText',
    'disableBackdropClose',
    'disableKeyboardClose',
    'disableCloseButton',
    'ctaRow',
    'closed'
]);
export const CmModalPrompt = defineContainer('cm-modal-prompt', undefined, [
    'show',
    'hideBackdrop',
    'modalTitle',
    'modalText',
    'disableBackdropClose',
    'disableKeyboardClose',
    'disableCloseButton',
    'ctaRow',
    'position',
    'closed',
    'confirm',
    'cancel'
]);
export const CmPagination = defineContainer('cm-pagination', undefined, [
    'page',
    'lastPage',
    'condensed',
    'condensedText',
    'disabled',
    'change-page'
]);
export const CmProgress = defineContainer('cm-progress', undefined, [
    'value',
    'text',
    'showPercentage',
    'type',
    'size',
    'color',
    'indeterminate',
    'circleSize',
    'strokeWidth',
    'clicked'
]);
export const CmRangeSlider = defineContainer('cm-range-slider', undefined, [
    'min',
    'max',
    'step',
    'unit',
    'color',
    'size',
    'hideTooltip',
    'singleSlider',
    'value'
]);
export const CmRow = defineContainer('cm-row', undefined);
export const CmSelect = defineContainer('cm-select', undefined, [
    'type',
    'size',
    'placeholder',
    'label',
    'error',
    'required',
    'name',
    'disabled',
    'multiple',
    'hideBottomSpacing',
    'hintTooltip',
    'value',
    'prependIcon',
    'appendIcon',
    'items',
    'clearable',
    'cm-change'
], 'value', 'v-on-change');
export const CmSideNavigation = defineContainer('cm-side-navigation', undefined, [
    'open',
    'logoLink',
    'collapseText',
    'routes',
    'expandedLogo',
    'condensedLogo',
    'toggled'
]);
export const CmSidePanel = defineContainer('cm-side-panel', undefined, [
    'visible',
    'hideBackdrop',
    'disableBackdropClose',
    'disableKeyboardClose',
    'disableCloseButton',
    'routes',
    'side',
    'closed'
]);
export const CmSnackbar = defineContainer('cm-snackbar', undefined, [
    'show',
    'showClose',
    'text',
    'action',
    'fadeTimeout',
    'closed'
]);
export const CmStatsCard = defineContainer('cm-stats-card', undefined, [
    'backgroundColor',
    'color',
    'iconColor',
    'statName',
    'statDescription',
    'statValue',
    'iconName',
    'grow'
]);
export const CmStatusDot = defineContainer('cm-status-dot', undefined, [
    'color',
    'size'
]);
export const CmTab = defineContainer('cm-tab', undefined, [
    'selected',
    'disabled',
    'noGutters',
    'iconName',
    'notifyBadge'
]);
export const CmTable = defineContainer('cm-table', undefined, [
    'selectable',
    'hideHeader',
    'lockFirstCol',
    'columns',
    'sort-change',
    'select-all'
]);
export const CmTableCell = defineContainer('cm-table-cell', undefined);
export const CmTableRow = defineContainer('cm-table-row', undefined, [
    'selectable',
    'selected',
    'toggled'
]);
export const CmTabs = defineContainer('cm-tabs', undefined, [
    'size',
    'type',
    'hasDivider'
]);
export const CmTag = defineContainer('cm-tag', undefined, [
    'size',
    'backgroundColor',
    'color',
    'tagStyle',
    'prependIcon',
    'deletable',
    'ellipsis',
    'maxWidth',
    'noRadius',
    'deleted'
]);
export const CmTextarea = defineContainer('cm-textarea', undefined, [
    'size',
    'placeholder',
    'label',
    'error',
    'required',
    'value',
    'name',
    'autoFocus',
    'disabled',
    'max',
    'min',
    'hideBottomSpacing',
    'clearable',
    'hintTooltip',
    'prependIcon',
    'appendIcon',
    'rows',
    'readonly',
    'cm-change'
], 'value', 'v-on-change');
export const CmToggle = defineContainer('cm-toggle', undefined, [
    'value',
    'type',
    'size',
    'disabled',
    'partial',
    'overrideToggle',
    'toggled'
], 'value', 'v-on-change');
export const CmTooltip = defineContainer('cm-tooltip', undefined, [
    'activateOnHover',
    'position',
    'align',
    'type',
    'text',
    'visible',
    'offset',
    'disabled'
]);
export const CmTopNavbar = defineContainer('cm-top-navbar', undefined, [
    'routes',
    'actionsLink',
    'profileMenuLinks',
    'signInUrl',
    'signUpUrl',
    'actionsLinkNotify',
    'signedIn',
    'profilePicUrl',
    'searchPlaceholderText',
    'homepageUrl',
    'searchEnabled',
    'desktopLogo',
    'mobileLogo',
    'search'
]);
//# sourceMappingURL=components.js.map